import React, { useEffect, useRef } from 'react';
import FormInput from '../../../shared/components/ui/FormInput';
import { ASSIGNEE_KIND_OPTIONS } from './assigneeKind';

const AssigneePicker = ({
  register,
  watch,
  setValue,
  prefix = '',
  usersOptions = [],
  spOptions = [],
  vendorOptions = [],
  width = 100
}) => {
  const kindKey = prefix ? `${prefix}assigneeKind` : 'assigneeKind';
  const userKey = prefix ? `${prefix}assignedTo_id` : 'assignedTo_id';
  const spKey = prefix ? `${prefix}assignedTo_sp_id` : 'assignedTo_sp_id';
  const vendorKey = prefix ? `${prefix}assignedTo_vendor_id` : 'assignedTo_vendor_id';
  const kind = watch(kindKey) || 'employee';
  const previousKind = useRef(kind);
  const withPlaceholder = (opts) => [{ label: 'Select...', value: '' }, ...(opts || [])];
  const setId = (key) => (value) =>
    setValue(key, value, { shouldDirty: true, shouldValidate: true });

  useEffect(() => {
    if (previousKind.current === kind) return;
    previousKind.current = kind;
    if (kind === 'employee') {
      setValue(spKey, '');
      setValue(vendorKey, '');
    } else if (kind === 'service_provider') {
      setValue(userKey, '');
      setValue(vendorKey, '');
    } else if (kind === 'vendor') {
      setValue(userKey, '');
      setValue(spKey, '');
    }
  }, [kind, setValue, userKey, spKey, vendorKey]);

  return (
    <>
      <FormInput
        label="Assignee type"
        register={register}
        register_key={kindKey}
        type="dropdown"
        options={ASSIGNEE_KIND_OPTIONS}
        isRequired={true}
        width={width}
      />
      {kind === 'employee' && (
        <FormInput
          label="Assigned To"
          register={register}
          register_key={userKey}
          type="dropdown"
          options={withPlaceholder(usersOptions)}
          onDropdownChange={setId(userKey)}
          isRequired={true}
          width={width}
        />
      )}
      {kind === 'service_provider' && (
        <FormInput
          label="Assigned To (Service Provider)"
          register={register}
          register_key={spKey}
          type="dropdown"
          options={withPlaceholder(spOptions)}
          onDropdownChange={setId(spKey)}
          isRequired={true}
          width={width}
        />
      )}
      {kind === 'vendor' && (
        <FormInput
          label="Assigned To (Vendor)"
          register={register}
          register_key={vendorKey}
          type="dropdown"
          options={withPlaceholder(vendorOptions)}
          onDropdownChange={setId(vendorKey)}
          isRequired={true}
          width={width}
        />
      )}
    </>
  );
};

export default AssigneePicker;
